// import { path, prop } from "ramda";
export var selectOpenBottomTabs = function selectOpenBottomTabs(store) {
    var state = store.BottomTabsReducer;
    return state ? state.openTabs : [];
};
export var selectBottomTabIndex = function selectBottomTabIndex(store) {
    var state = store.BottomTabsReducer;
    return state ? state.index : -1;
};
